import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Add, ReplaceOne, DeleteOne } from '@tencent/adp-icons-react';
import { usePrefixCls } from '../../../../../config/hooks/usePrefixCls';
import { ImageItem } from '../ImageItem';
var UploadCard = function UploadCard(props) {
  var id = props.id,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$text = props.text,
    text = _props$text === void 0 ? '上传图片' : _props$text,
    image = props.image,
    _props$size = props.size,
    size = _props$size === void 0 ? 86 : _props$size,
    isSelected = props.isSelected,
    onClick = props.onClick,
    onDelete = props.onDelete,
    onRepeat = props.onRepeat,
    onSelect = props.onSelect;
  var cls = usePrefixCls('material-library-multiple-upload-card');
  var finalStyle = _objectSpread(_objectSpread({}, style), {}, {
    width: size,
    height: size,
    border: isSelected ? '1px solid #296BEF' : '1px dashed #CDCFD5',
    boxShadow: isSelected ? '0 0 0 1px #296BEF' : 'none'
  });
  return React.createElement("div", {
    className: cls,
    style: finalStyle
  }, image.imageUrl && React.createElement("div", {
    className: 'item',
    onClick: function onClick() {
      return onSelect(id);
    }
  }, React.createElement(DeleteOne, {
    onClick: function onClick(event) {
      event.stopPropagation();
      onDelete(id);
    },
    className: 'delete',
    fill: "#000000",
    size: 15
  }), React.createElement(ReplaceOne, {
    onClick: function onClick(event) {
      event.stopPropagation();
      onRepeat(id);
    },
    className: 'replace',
    fill: "#000000",
    size: 15
  }), React.createElement(ImageItem, {
    value: image
  })), !image.imageUrl && React.createElement("div", {
    className: 'empty',
    onClick: onClick
  }, React.createElement(Add, {
    size: 20,
    fill: '#AAAFBB'
  }), text));
};
export var UploadCardGroup = function UploadCardGroup(props) {
  var _a, _b;
  var value = props.value,
    count = props.count,
    selectedId = props.selectedId,
    _props$cardStyle = props.cardStyle,
    cardStyle = _props$cardStyle === void 0 ? {} : _props$cardStyle,
    _props$groupStyle = props.groupStyle,
    groupStyle = _props$groupStyle === void 0 ? {} : _props$groupStyle,
    onClick = props.onClick,
    onDelete = props.onDelete,
    onRepeat = props.onRepeat,
    onSelect = props.onSelect;
  var cards = [];
  var cStyle = _objectSpread({
    marginRight: 5,
    marginBottom: 5
  }, cardStyle);
  var gStyle = _objectSpread({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap'
  }, groupStyle);
  for (var i = 0; i < count; i++) {
    cards.push(React.createElement(UploadCard, {
      id: (_a = value[i]) === null || _a === void 0 ? void 0 : _a.materialId,
      isSelected: ((_b = value[i]) === null || _b === void 0 ? void 0 : _b.materialId) === selectedId,
      key: i.toString(),
      style: cStyle,
      image: value[i] || {},
      onClick: onClick,
      onSelect: onSelect,
      onDelete: onDelete,
      onRepeat: onRepeat
    }));
  }
  return React.createElement("div", {
    style: gStyle
  }, cards);
};